const { fetchSingle: fetchSingleSection } = window.BAO.sectionRenderer

class ProductCard extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupObservers()
  }

  setupObservers () {
    if (!this.productUrl) return

    this.onEntry = this.onEntry.bind(this)

    this.observer = new IntersectionObserver(this.onEntry, {
      threshold: 0,
    })

    this.observer.observe(this)
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    observer.unobserve(this)

    this.fetchProductContent()
  }

  async fetchProductContent () {
    try {
      const response = await fetchSingleSection(
        'product-card-colors',
        this.productUrl,
      )

      const newDOM = window.BAO.sectionRenderer.convertToDOM(response)

      const coloursContent = newDOM.querySelector('.prd-CardColors')

      this.els.colors.element.innerHTML = coloursContent.outerHTML
    } catch (error) {
      console.error(error)
    }
  }

  get productUrl () {
    return this.dataset.productUrl || ''
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard)
}
